import StarIcon from '@/components/atoms/starIcon'

const Point = ({ text }) => {
  const baseContainer =
    'relative w-full flex items-center gap-x-[9px] lg:gap-x-[19px]'
  const base =
    'text-[12px] md:text-[15px] leading-[150%] font-light text-olive font-chivoMono'

  return (
    <div className={baseContainer}>
      <StarIcon className="w-[7px] h-[7px] md:w-[12px] md:h-[12px]" />
      <p className={base}>{text}</p>
    </div>
  )
}

export default Point
